import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
import { Link, Navigate } from "react-router-dom";

const ListPermissions = () => {
    const [loading, setLoading] = useState(false);
    const [rol_id, setRolId] = useState(0);
    const [permissions, setPermissions] = useState([]);
    const [active, setActive] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [status_filter, setStatusFilter] = useState(2);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAll();
        setTimeout(() => {
            $('.select2').select2({ width: "100%" });
        }, 100);
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, []);

    const selectStatus = [
        { label: 'Todos', value: 2 },
        { label: 'Activo', value: 1 },
        { label: 'Inactivo', value: 0 }
    ];

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    const getAll = async () => {
        setLoading(true);
        var table = $('.main').DataTable();
        table.destroy();
        const form = new FormData();
        form.append("status", status_filter);
        await axios.post(ENDPOINT + "get-permissions-by-rol", form).then((response) => {
            setPermissions(response.data.data);
            setActive(response.data.data.filter((e) => e.status === 1).length);
            setInactive(response.data.data.filter((e) => e.status === 0).length);
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 10,
                    responsive: true,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar por socio",
                    },
                });
                setLoading(false);
            }, 100);
        })
        .catch(function (error) {
            setLoading(false);
            console.log(error);
        });
    };

    const toggleSwitch = async (val) => {
        setLoading(true);
        await axios
            .get(ENDPOINT + "get-partner-status/" + val)
            .then((response) => {
                getAll();
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const handleDelete = (id, name) => {
        Swal.fire({
            title: `¿Desea eliminar el registro [ ${name} ] ?`,
            text: "Si elimina el permiso, el rol perderá todos los permisos y accesos al sistema. No podrá recuperarlo.",
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(ENDPOINT + "delete-permission/" + id).then((response) => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
                    .catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    });
            }
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    return (
        <>
            {loading && <Loader />}
            <div className="container-fluid">
                <ContentHeader title="Módulo de Permisos" />
            </div>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-shield-check me-2"></i> Listado de Permisos
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <Link
                                    to={"/permisos"}
                                    className="btn btn-success btn-sm me-1">
                                    <i className="fas fa-plus-circle me-1"></i> Agregar
                                </Link>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="list-permissions-indications row mb-4">
                            <div className="col-md-4 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="select_status" className="col-form-label col-form-label-sm">
                                        Estado
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="status_filter"
                                        name="status_filter"
                                    >
                                        {selectStatus.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="list-permissions-field-hint">Filtra los permisos por su estado</small>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                <button
                                    onClick={() => getAll()}
                                    className="btn btn-primary btn-sm me-1"
                                    type="button" >
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                            </div>
                            <div className="col-xs-2 col-md-4">
                                <div className="form-group">
                                    <table className="table">
                                        <thead>
                                            <tr className="text-center">
                                                <td className="indications-table" width="30%" >Total</td>
                                                <td className="indications-table "width="30%" >Activos</td>
                                                <td className="indications-table "width="30%" >Inactivos</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td id="TuserT">{active + inactive}</td>
                                                <td id="TuserA">{active}</td>
                                                <td id="TuserI">{inactive}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-left">Rol</th>
                                    <th className="text-center">Cantidad de Permisos</th>
                                    <th className="text-center">Estado</th>
                                    <th className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {permissions.map((item, index) => (
                                    <tr key={index}>
                                         <td>
                                            <kbd># {parseInt(index) + 1}</kbd>
                                        </td>
                                        <td>
                                            {item.rol_name}
                                        </td>
                                        <td className="text-center">
                                            {item.total_permissions}
                                        </td>
                                        <td className="text-center">
                                            <div data-bs-toggle="tooltip" data-bs-placement="top" title="Estado">
                                                <Switch
                                                    checkedIcon={false}
                                                    uncheckedIcon={false}
                                                    checked={item.status === 1 ? true : false}
                                                    onChange={() => toggleSwitch(item.rol_id)}
                                                />
                                            </div>
                                        </td>      
                                        <td className="text-center">
                                            <div>
                                                <span
                                                    title="Editar registro"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top">
                                                    <Link
                                                        className="btn-sm btn btn-warning me-1"
                                                        to={"/permisos/" + item.rol_id}>
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </Link>
                                                </span>
                                                <button
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={item.rol_id === 1 || item.rol_id === 2 ? "No se puede eliminar este registro" : "Eliminar registro"}
                                                    className={`btn-sm btn ${item.rol_id === 1 || item.rol_id === 2 ? 'btn-outline-danger' : 'btn-danger'} me-1`}
                                                    onClick={() => handleDelete(item.rol_id, item.rol_name)}
                                                    disabled={item.rol_id === 1 || item.rol_id === 2}
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ListPermissions;
